import {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useState
} from "react";
import {
  INITIAL_NETWORK_REFERENCES_LIMIT,
  NETWORK_REFERENCES_INCREMENT
} from "../components/report_summary/hooks";

type SampleDetailsContextType = {
  networkReferences: {
    networkReferencesCountCtx: number;
    increaseNetworkReferencesCountCtx: (size?: number) => void;
  };
};

const SampleDetailsContext = createContext<
  SampleDetailsContextType | undefined
>(undefined);

export const SampleDetailsProvider: FC<PropsWithChildren> = ({ children }) => {
  const [networkReferencesCountCtx, setNetworkReferencesCountCtx] = useState(
    INITIAL_NETWORK_REFERENCES_LIMIT
  );

  const increaseNetworkReferencesCountCtx = (
    size = NETWORK_REFERENCES_INCREMENT
  ) => {
    setNetworkReferencesCountCtx(prevCount => prevCount + size);
  };

  const value = {
    networkReferences: {
      networkReferencesCountCtx,
      increaseNetworkReferencesCountCtx
    }
  };

  return (
    <SampleDetailsContext.Provider value={value}>
      {children}
    </SampleDetailsContext.Provider>
  );
};

export const useSampleDetailsContext = () => {
  const context = useContext(SampleDetailsContext);
  if (!context) {
    throw new Error(
      "useSampleDetailsContext must be used within a SampleDetailsProvider"
    );
  }
  return context;
};
